import styled from "styled-components";
import { Select, Radio, Checkbox, Input } from "antd";

export const FormGroup = styled.div`
  margin-bottom: 24px;
  width: 100%;
`;

export const Label = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 13px;
  font-family: 'Manrope', sans-serif;
`;

export const FullWidth = styled.div`
  width: 100%;
`;

export const StyledInput = styled(Input)`
  height: 40px;
  border-radius: 6px;
  font-size: 13px;
  font-family: "Manrope", sans-serif;
`;

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-wrapper {
    display: flex; /* align checkbox and label */
    align-items: flex-start;
    margin-bottom: 12px; /* spacing between checkboxes */
    font-family: "Manrope", sans-serif;
    font-size: 13px;
    max-width: 100%;
    margin: 0 16px 8px 0;

    .ant-checkbox {
      // margin-top: 2px; /* small top margin for alignment */
      // height: 100%;
    }

    .ant-checkbox + span {
      display: inline-block;
      max-width: 100%;
      white-space: normal;
      word-break: break-word;
      overflow: hidden;
      vertical-align: middle;
    }
  }

  .ant-checkbox-inner {
    border-radius: 4px;
    width: 16px;
    height: 16px;
  }
`;

export const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    margin: 0 16px 8px 0;
    font-family: "Manrope", sans-serif;
    font-size: 13px;

    // apply ellipsis to label span
    .ant-radio + span {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      white-space: normal;
      word-break: break-word;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      vertical-align: middle;
    }
  }

  .ant-radio-inner {
    width: 16px;
    height: 16px;
  }
`;

export const StyledDropdown = styled(Select)`
  width: 100%;
  font-size: 13px;
  .ant-select-selector {
    border-radius: 6px;
    height: 40px !important;
    display: flex;
    align-items: center;
  }

  .ant-select-arrow {
    top: 20px;
  }

  .ant-select-selection-placeholder {
    color: #a0a0a0;
  }
`;

export const StyledUnsupportedField = styled.div`
  color: red;
  font-size: 13px;
  margin-bottom: 12px;
  background-color: #fff3f3;
  padding: 8px 12px;
  border: 1px solid #ffcccc;
  border-radius: 6px;
  height: 40px;
`;
